export default function itemsInCartController() {
  const itemsInPack = document.querySelector('.product__items-in-pack');
  const packageInfo = document.querySelector('.product__package-details__text');

  if (itemsInPack && packageInfo) {
    let packText = itemsInPack.innerText.toUpperCase();
    let packageText = packageInfo.innerText.toUpperCase();

    packageText = packageText.replace(packText, '').trim();
    if (packageText[packageText.length - 1] === '|') {
      packageText = packageText.slice(0, -1);
    }

    packageInfo.innerText = packageText;
  }

  //TODO: remove after updating the package info texts
}
